<template>
  <section class="profile-workspace">
    <div class="workspace-welcome"><div><span class="workspace-eyebrow">WORKSPACE</span><h2>{{ userInfo.user_name || '管理员' }}，欢迎回来</h2><p>从这里开始处理订单、管理入库物品，或维护客户资料。</p></div><i class="el-icon-office-building welcome-icon"></i></div>
    <div class="workspace-shortcuts">
      <router-link :to="'/orders/order_status/' + reviewingStatus"><i class="el-icon-document-checked"></i><div><strong>订单处理</strong><span>审核订单与客服制单</span></div><i class="el-icon-arrow-right"></i></router-link>
      <router-link to="/items/scanned-items"><i class="el-icon-box"></i><div><strong>仓储管理</strong><span>查看入库与申报物品</span></div><i class="el-icon-arrow-right"></i></router-link>
      <router-link to="/user/users"><i class="el-icon-user"></i><div><strong>客户管理</strong><span>查看用户与联系资料</span></div><i class="el-icon-arrow-right"></i></router-link>
    </div>
    <el-card class="profile-card" shadow="never">
      <div slot="header" class="profile-card-heading"><span>账户资料</span><span class="profile-role">{{ roleMap[userInfo.role] || '管理端账户' }}</span></div>
      <dl class="profile-details"><div v-for="field in profileFields" :key="field.key"><dt>{{ field.label }}</dt><dd>{{ userInfo[field.key] || '—' }}</dd></div></dl>
      <div class="profile-security"><div><strong>账户安全</strong><p>通过邮箱重置您的登录密码。</p></div><el-button plain icon="el-icon-lock" @click="confirmResetPassword">重置密码</el-button></div>
    </el-card>
  </section>
</template>

<script>
import instance from '@/utils/axios.config'; // Adjust the path as necessary
import { MessageBox } from 'element-ui';

export default {
  data() {
    return {
        userInfo: {},
        reviewingStatus: process.env.VUE_APP_ORDER_STATUS_REVIEWING || '待审核',
        profileFields: [{key:'user_name',label:'用户名'},{key:'email',label:'邮箱'},{key:'mobile_phone',label:'联系电话'},{key:'first_name',label:'姓'},{key:'last_name',label:'名'}],
        roleMap: {
                    400: '超级管理员',
                    300:'管理员',
                    200: '经理',
                    100: '客服',
                // 其他角色...
            },  
    };
  },
  created() {
    this.loadData();
  },
  methods: {

     loadData() {
            instance.get(`/admins/admin_users?user_name=${localStorage.getItem('user_name')}&role=${localStorage.getItem('role')}`, {

            }).then(response => {
                this.userInfo = response.data.data[0] || {};
            }).catch(error => {
                console.error(error);
                // 处理令牌过期或其他错误，例如提示用户重新登录
            });
        },

        confirmResetPassword() {
      MessageBox.confirm('确定要重置密码吗?', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.sendResetPasswordEmail();
      }).catch(() => {
        // 用户取消操作
      });
    },
    sendResetPasswordEmail() {
      instance.post(`/auth/forget-password`, {
        user_name: this.userInfo.user_name,
        email: this.userInfo.email,
      })
      .then(response => {
        if (response.status === 200) {
          this.$message({
            type: 'success',
            message: '重置密码邮件已发送，请检查您的邮箱。',
          });
        }
      })
      .catch(error => {
        console.error('Error sending reset password email:', error);
        this.$message.error('发送重置密码邮件失败。');
      });
    },
  }
};
</script>

<style scoped>

.workspace-welcome { display:flex; justify-content:space-between; align-items:center; padding:28px 32px; background:#eaf0fc; border:1px solid #dde6f7; border-radius:12px; margin-bottom:22px; }
.workspace-eyebrow { font-size:10px; letter-spacing:2px; color:#5577af; font-weight:600; }
.workspace-welcome h2 { margin:10px 0; font-size:24px; font-weight:600; color:#233b60; }
.workspace-welcome p { font-size:13px; color:#6c7e97; line-height:1.7; }
.welcome-icon { font-size:60px; color:#9ab4de; padding-left:20px; }
.workspace-shortcuts { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:18px; margin-bottom:26px; }
.workspace-shortcuts a { display:flex; align-items:center; gap:14px; padding:22px; border:1px solid #e7ecf3; border-radius:10px; background:white; text-decoration:none; color:#233248; }
.workspace-shortcuts a:hover { border-color:#9bb8f3; box-shadow:0 4px 16px #23324808; }
.workspace-shortcuts a > i:first-child { padding:12px; background:#f0f5ff; color:#3975dc; border-radius:10px; font-size:22px; }
.workspace-shortcuts a > i:last-child { margin-left:auto; color:#9aa7ba; font-size:12px; }
.workspace-shortcuts strong { display:block; font-size:14px; font-weight:600; }
.workspace-shortcuts span { display:block; font-size:11px; margin-top:7px; color:#748297; }
.profile-card-heading { display:flex; justify-content:space-between; align-items:center; }
.profile-role { font-size:11px; padding:5px 10px; border-radius:5px; color:#33756a; background:#edf7f4; font-weight:400; }
.profile-details { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:26px; padding:4px 4px 28px; }
.profile-details dt { font-size:12px; color:#748297; margin-bottom:9px; }
.profile-details dd { font-size:14px; color:#233248; overflow-wrap:anywhere; }
.profile-security { display:flex; justify-content:space-between; align-items:center; gap:16px; border-top:1px solid #e7ecf3; padding:22px 4px 0; }
.profile-security strong { font-size:13px; font-weight:500; }
.profile-security p { font-size:12px; color:#748297; margin-top:7px; }
@media(max-width:1100px) { .workspace-shortcuts { grid-template-columns:1fr; gap:12px; } }
@media(max-width:640px) { .workspace-welcome { padding:22px; } .workspace-welcome h2 { font-size:20px; } .welcome-icon { display:none; } .profile-details { grid-template-columns:1fr 1fr; } }

</style>